import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { FaShareAlt, FaEnvelope } from 'react-icons/fa';
import API_URL from '../api/APIUrl';

export const StudentPublic = () => {
  const { id } = useParams();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showPopup, setShowPopup] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);

  const handleContactAdmin = (student) => {
    setSelectedStudent(student);
    setShowPopup(true);
  };
  

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const response = await fetch(`${API_URL.GET_PUBLIC_SINGLE_STUDENT_BY_ID}${id}`);
        const data = await response.json();
        console.log(data);
      
          setStudent(data);
      
      } catch (err) {
        setError('Failed to fetch student');
      }
      setLoading(false);
    };
    fetchStudent();
  }, [id]);



  const handleShare = (student) => {
    const balanceFees = calculateBalance(student.total_fees, student.arranged_amount);
    const formattedName = formatName(student.firstname, student.middlename, student.surname);
  
    const studentDetails = `Student: ${formattedName}
  State: ${student.state}
  City: ${student.city}
  Religion: ${student.religion}
  Caste: ${student.caste}
  Sub-Caste: ${student.subCaste}
  Education: ${student.education_category}
  Needs Help for: ${student.need_financial_help_for}
  Total Fees: ${student.total_fees}
  Arranged: ${student.arranged_amount}
  Balance Fees: ${balanceFees}`;
  
    navigator.share({ 
      text: studentDetails, 
      url: `${API_URL.GET_BASE}student/${student._id}` 
    });
  };


  const formatName = (firstname, middlename = '', surname = '') => {
    const middleInitial = middlename ? middlename.charAt(0).toUpperCase() + '.' : '';
    const lastInitial = surname ? surname.charAt(0).toUpperCase() + '.' : '';
    return `${firstname} ${middleInitial} ${lastInitial}`.trim();
  };
  
  const calculateBalance = (total, arranged) => {
    const totalAmt = Number(total) || 0;
    const arrangedAmt = Number(arranged) || 0;
    return totalAmt - arrangedAmt;
  };



  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-danger">{error}</p>;

  return (
    <div className="container mt-4">
      <h2>Student Details</h2>
      <div className="card p-3">
      <h5>{formatName(student.firstname, student.middlename, student.surname)}</h5>
              <p>State: {student.state}, City: {student.city}</p>
              <p>Education: {student.education_category}</p>
              <p>Needs Help for: {student.need_financial_help_for}</p>
              <p>Total Fees: {student.total_fees}</p>
              <p>Arranged: {student.arranged_amount}</p>
              <p>Balance: {calculateBalance(student.total_fees, student.arranged_amount)}</p>
              <p>Religion: {student.religion}, Caste: {student.caste}, Sub-Caste: {student.subCaste}</p>
        <div className="mt-3">
          <button className="btn btn-secondary mx-2" onClick={() => handleContactAdmin(student)}>
              <FaEnvelope /> Contact Admin
          </button>
          <button className="btn btn-info" onClick={() => handleShare(student)}>
              <FaShareAlt /> Share
          </button>
        </div>



          {showPopup && selectedStudent && (
            <div className="modal d-block" tabIndex="-1" role="dialog" style={{ background: 'rgba(0,0,0,0.5)' }}>
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Contact Admin</h5>
                    <button type="button" className="close" onClick={() => setShowPopup(false)}>
                      <span>&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>You can contact the admin to help this student:</p>
                    <p><strong>Name:</strong> {formatName(selectedStudent.firstname, selectedStudent.middlename, selectedStudent.surname)}</p>
                    <p><strong>Email:</strong> <a href="mailto:admin@example.com">admin@example.com</a></p>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowPopup(false)}>Close</button>
                  </div>
                </div>
              </div>
            </div>
          )}
      </div>
    </div>


  );
};

export default StudentPublic;
